import { seasonEntries } from "@/mocks/homeData";

export default function SeasonSection() {
  return (
    <section id="season" className="w-full bg-primary-950 py-16 md:py-24 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium tracking-wide text-accent-300">
            <span className="w-6 h-px bg-accent-400"></span>
            第二季与续集
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold leading-snug">
            漂亮的小姨子第二季与续集：先分清概念，再决定怎么追
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
            关于第二季与续集，读者最常卡住的地方不是“有没有”，而是“算不算同一部”。下面这几个问题覆盖了最常见的疑问，帮助你建立清晰的查找顺序。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {seasonEntries.map((entry, index) => (
            <article
              key={entry.id}
              className={`rounded-lg border border-background-50/15 p-5 md:p-6 ${
                index === 0 ? "bg-accent-500 text-secondary-950 md:col-span-1" : "bg-background-50/5"
              }`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`w-10 h-10 flex items-center justify-center rounded-md text-lg ${
                    index === 0 ? "bg-secondary-950/15 text-secondary-950" : "bg-background-50/10 text-accent-300"
                  }`}
                >
                  <i className={entry.icon}></i>
                </span>
                <span className={`text-xs ${index === 0 ? "text-secondary-800" : "text-background-300"}`}>
                  0{index + 1}
                </span>
              </div>
              <h3
                className={`mt-4 font-heading text-base md:text-lg font-semibold ${
                  index === 0 ? "text-secondary-950" : "text-background-50"
                }`}
              >
                {entry.title}
              </h3>
              <p
                className={`mt-2 text-sm leading-relaxed ${
                  index === 0 ? "text-secondary-900" : "text-background-200"
                }`}
              >
                {entry.desc}
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {entry.tags.map((tag) => (
                  <span
                    key={tag}
                    className={`px-2.5 py-1 text-xs rounded-full whitespace-nowrap ${
                      index === 0
                        ? "bg-secondary-950/15 text-secondary-900"
                        : "bg-background-50/10 text-background-100"
                    }`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}